export const DISPLAY_SETTINGS_FETCH_SUCCESS = Symbol('DISPLAY_SETTINGS_FETCH_SUCCESS');
export const DISPLAY_SETTINGS_SET_START_CHANNEL = Symbol('DISPLAY_SETTINGS_SET_START_CHANNEL');
export const DISPLAY_SETTINGS_UPDATE_START_CHANNELS = Symbol('DISPLAY_SETTINGS_UPDATE_START_CHANNELS');
export const DISPLAY_SETTINGS_YAMMER_IS_LOADED = Symbol('DISPLAY_SETTINGS_YAMMER_IS_LOADED');
export const DISPLAY_SETTINGS_MICROSOFT_TEAMS_IS_LOADED = Symbol('DISPLAY_SETTINGS_MICROSOFT_TEAMS_IS_LOADED');
export const DISPLAY_SETTINGS_FACEBOOK_SDK_IS_LOADED = Symbol('DISPLAY_SETTINGS_FACEBOOK_SDK_IS_LOADED');
export const ADD_TOGGLES = Symbol('ADD_TOGGLES');

/**
 * @param {*} settings
 * @return {{type: symbol, payload: {settings: *}}}
 */
export const displaySettingsFetchSuccessAction = (settings) => ({
  type: DISPLAY_SETTINGS_FETCH_SUCCESS,
  payload: { settings },
});

/**
 * @param {*[]} startChannels
 * @return {{type: symbol, payload: {startChannels: *}}}
 */
export const setStartChannelsAction = (startChannels) => {
  return {
    type: DISPLAY_SETTINGS_SET_START_CHANNEL,
    payload: {
      startChannels,
    },
  };
};

/**
 * @param {*[]} startChannels
 * @return {{type: symbol, payload: {startChannels: *}}}
 */
export const updateStartChannelsAction = (startChannels) => {
  return {
    type: DISPLAY_SETTINGS_UPDATE_START_CHANNELS,
    payload: {
      startChannels,
    },
  };
};

export const setYammerLoadedAction = () => {
  return {
    type: DISPLAY_SETTINGS_YAMMER_IS_LOADED,
  };
};

export const setMicrosoftTeamsLoadedAction = () => {
  return {
    type: DISPLAY_SETTINGS_MICROSOFT_TEAMS_IS_LOADED,
  };
};

export const setFacebookSdkLoadedAction = () => {
  return {
    type: DISPLAY_SETTINGS_FACEBOOK_SDK_IS_LOADED,
  };
};

export const addToggles = (payload) => ({
  type: ADD_TOGGLES,
  payload,
});
